<template>
    <svg width="18px" height="13px" viewBox="0 0 18 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <filter x="-3.6%" y="-2.9%" width="107.1%" height="108.2%" filterUnits="objectBoundingBox" id="filter-1">
                <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                    <feMergeNode in="SourceGraphic"></feMergeNode>
                </feMerge>
            </filter>
        </defs>
        <g id="Dashboard-DNA" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="AI-Profiler---Sort" transform="translate(-480, -533)" fill="#359685" fill-rule="nonzero">
                <g id="Group-3" filter="url(#filter-1)" transform="translate(324, 504)">
                    <g id="Group-18" transform="translate(19, 20)">
                        <g id="Group-17" transform="translate(141, 4)">
                            <g id="arrow_drop_down_FILL1_wght400_GRAD0_opsz24" transform="translate(0, 7)">
                                <polygon id="Path" points="5 5 0 0 10 0"></polygon>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>